import { Box, Button, IconButton, useTheme } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { tokens } from '../../../global/theme/tokens';

const CustomVar = ({ element, onDelVar, onClick }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  return (
    <Box className="flex flex-row justify-start items-center gap-2">
      <IconButton
        onClick={() => onDelVar(element.id || element.uuid)}
        size="small"
      >
        <DeleteOutlineIcon />
      </IconButton>
      <Button
        onClick={() => onClick(element.identifier)}
        className="w-full"
        sx={{
          bgcolor: colors.bgInput,
          border: `1px solid transparent`,
          ':hover': {
            bgcolor: colors.info + '30',
            border: `1px solid ${colors.info}80`,
          },
          justifyContent: 'start',
        }}
      >
        {element.displayName}
      </Button>
    </Box>
  );
};

export default CustomVar;
